import { render, staticRenderFns } from "./InstallmentImport.vue?vue&type=template&id=1a5bf4aa"
import script from "./InstallmentImport.vue?vue&type=script&lang=js"
export * from "./InstallmentImport.vue?vue&type=script&lang=js"
import style0 from "./InstallmentImport.vue?vue&type=style&index=0&id=1a5bf4aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports